export default __webpack_public_path__ + "static/media/icon_withdraw_points.ed5a2dd6.svg";